import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { Redirect } from 'react-router';
import { SubscriptionsService } from '../../../services/SubscriptionService';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';

interface Props {
    register?: (form: FormAdhere3) => void;
    hidden: boolean;
    disabled: boolean;
    switch?: (n: number) => void;
    user_id: number;
}

interface State {
    agree: boolean;
    photoId: File | null;
    certifMed: File | null;
    attAssur: File | null;
    decharges: ReqType.Decharges;
    redirect?: boolean;
}

/**
 * Ce composant permet l'affichage du fomulaire d'adhesion partie3
 */
export class FormAdhere3 extends React.Component {

    props: Props;
    state: State;
    decharge: ReqType.Decharges = {id: 0, contenu_decharge: '', contenu_droit: ''};

    constructor(props: Props) {
        super(props);
        if (this.props.register !== undefined) {
            this.props.register(this);
        }

        this.state = {
            agree: false,
            photoId: null,
            decharges: this.decharge,
            certifMed: null,
            attAssur: null,
            redirect: false
        };
        this.getDecharges();
    }

    public getDecharges() {
        SubscriptionsService.getInstance().getDecharges()
            .then(
                (response) => {
                    this.setState({decharges: response[0]});
                }
            ).catch((reason) => {
            alert(reason);
        });
    }

    public getForm(): ReqType.SubscriptionPart3 | null {
        if (this.state.photoId === null) {
            alert('Veuillez mettre une photo d\'identité');
            return null;
        } else if (this.state.certifMed === null) {
            alert('Veuillez mettre un certificat médical');
            return null;
        } else if (this.state.attAssur === null) {
            alert('Veuillez mettre une attestation d\'assurance');
            return null;
        } else if (!this.state.agree && this.props.hidden === false) {
            alert('Veuillez cocher sur \'J\'accepte\' ');
            return null;
        }
        return {
            attestation_assurance: this.state.attAssur,
            certificat_medical: this.state.certifMed,
            photo_profil: this.state.photoId,
            valide: this.state.agree || this.props.hidden,
        };
    }

    previousPage = () => {
        if (this.props.switch !== undefined) {
            this.props.switch(2);
        }
    }

    valider = () => {
        if (this.state.photoId === null) {
            return Promise.resolve().then(
                () => {
                    alert('Veuillez mettre une photo d\'identité');
                    return Promise.reject('');
                }
            );
        } else if (this.state.certifMed === null) {
            return Promise.resolve().then(
                () => {
                    alert('Veuillez mettre un certificat médical');
                    return Promise.reject('');
                }
            );
        } else if (this.state.attAssur === null) {
            return Promise.resolve().then(
                () => {
                    alert('Veuillez mettre une attestation d\'assurance');
                    return Promise.reject('');
                }
            );
        } else if (!this.state.agree && this.props.hidden === false) {
            return Promise.resolve().then(
                () => {
                    alert('Veuillez cocher sur \'J\'accepte\' ');
                    return Promise.reject('');
                }
            );
        } else {
            var sub: ReqType.SubscriptionPart3 = {
                attestation_assurance: this.state.attAssur,
                certificat_medical: this.state.certifMed,
                photo_profil: this.state.photoId,
                valide: this.state.agree
            };
            return (SubscriptionsService.getInstance().createSubscribePart3(sub, this.props.user_id).then(
                () => {
                    alert('Vous receverez un mail de confrimation lorsque l\'inscription sera validée.');
                    this.setState({ redirect: true });
                }
            ).catch(
                (erreur) => {
                    JSON.stringify(erreur);
                }
            )
        );
        }
    }

    setPhotoId = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files !== null) {
            this.setState({ photoId: event.target.files[0] });
        }
    }

    setCertifMed = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files !== null) {
            this.setState({ certifMed: event.target.files[0] });
        }
    }

    setAttAssur = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files !== null) {
            this.setState({ attAssur: event.target.files[0] });
        }
    }

    setAgree = () => {
        this.state.agree = !this.state.agree;
        this.setState({ agree: this.state.agree });
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={'/home'} />;
        }
        const hStyle = {
            color: '#ED008C',
            paddingTop : '30px',
            paddingBottom: '50px',
            fontSize: '40px'
        };
        return (
            <div>
                <h2 className="text-center" style={hStyle} hidden={this.props.hidden}>Bulletin d'adhésion</h2>
                <h3 hidden={this.props.hidden} className="text-center" style={{float: 'left', marginBottom: '2cm'}}>
                    Pièces à fournir
                </h3>
                <br/>
                <hr hidden={this.props.hidden}/>
                <table className="table table-hover">
                    <tbody>
                        <tr>
                            <td>- Une photo d'identité</td>
                            <td>
                                <input
                                    type="file"
                                    className="form-control-file"
                                    disabled={this.props.disabled}
                                    onChange={this.setPhotoId}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td> - Un certificat médical pour l’année 2018/2019.</td>
                            <td>
                                <input
                                    onChange={this.setCertifMed}
                                    type="file"
                                    disabled={this.props.disabled}
                                    className="form-control-file"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                - Une attestation d’assurance 2018/2019
                                (ou signature de la décharge de responsabilité).
                            </td>
                            <td>
                                <input
                                    type="file"
                                    disabled={this.props.disabled}
                                    className="form-control-file"
                                    onChange={this.setAttAssur}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td hidden={this.props.hidden}>
                                - Paiement complet (si paiement en plusieurs fois, apporter tous les chèques).
                        </td>
                        </tr>
                    </tbody>
                </table>
                <blockquote hidden={this.props.hidden}>
                    <h3 style={{marginTop: '1cm', marginBottom: '0.5cm'}}>Droit à l'image</h3>
                    <hr/>
                    <p style={{textAlign: 'justify', marginRight: '20px'}}>{this.state.decharges!.contenu_droit}</p>
                    <h3 style={{marginTop: '1cm', marginBottom: '0.5cm'}}>Décharge de résponsabilité</h3>
                    <hr/>
                    <p style={{textAlign: 'justify', marginRight: '20px'}}>{this.state.decharges!.contenu_decharge}</p>
                </blockquote>
                <div className="row checkbox checkbox-success" hidden={this.props.hidden}>
                    <input
                        type="checkbox"
                        id="checkbox2"
                        style={{marginRight: '5px', marginLeft: '15px', marginTop: '6px'}}
                        onClick={this.setAgree}
                        className="styled"
                    />
                    <p> J'accepte</p>
                </div>
                <div className="row" hidden={this.props.hidden} style={{float: 'right', marginRight: '1cm'}}>
                    <button
                        className="btn"
                        onClick={this.previousPage}
                        style={{
                            marginBottom: '1cm',
                            height: '1.5cm',
                            marginTop: '1cm',
                            width: '4cm'}}
                    >
                        Precedent
                    </button>
                    <LoaderButton
                        className="btn"
                        onClick={this.valider}
                        style={{
                            marginLeft: '1cm',
                            marginBottom: '1cm',
                            height: '1.5cm',
                            marginTop: '1cm',
                            width: '4cm'}}
                    >
                        Valider
                    </LoaderButton>

                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MembershipPage/internalComponents/Adhere3.tsx